import ModalWrapper from 'components/common/overlays/ModalWrapper';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import useModal from 'hooks/useModal';
import styles from 'styles/pages/modal/EvaluationDetail.module.scss';
import { useQuery } from 'react-query';
import { getProfessorFeedbackHistory } from 'apis/professor';
import { TEvaluationChartFeedbackHistoryParams } from 'types/apis/professor';

type TProps = {
  isProfessor: boolean;
  evaluationChartId: number;
  userId: number;
  feedbackId: number;
};

const EvaluationDetail = ({
  isProfessor,
  evaluationChartId,
  userId,
  feedbackId,
}: TProps) => {
  const { closeModal } = useModal();

  const handleClose = () => {
    closeModal();
  };

  const params = {
    evaluationChartId,
    userId: userId,
    feedbackId: feedbackId,
  };

  // 차트 평가 이력 조회
  const { data: getProfessorFeedbackHistoryData } = useQuery(
    [
      'getProfessorFeedbackHistory',
      userId,
      params.feedbackId,
      params.evaluationChartId,
    ],
    () =>
      getProfessorFeedbackHistory(
        params as TEvaluationChartFeedbackHistoryParams
      ),
    {
      enabled:
        isProfessor &&
        !!userId &&
        !!params.feedbackId &&
        !!params.evaluationChartId,
    }
  );

  return (
    <ModalWrapper>
      <div className="flex justify_between items_center">
        <h2 className={styles.title}>평가 이력 보기</h2>
        <button type="button" onClick={handleClose}>
          <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>평가 날짜</th>
            <th>점수</th>
          </tr>
        </thead>
        <tbody>
          {getProfessorFeedbackHistoryData?.data.evaluationHistoryList
            .length !== 0 ? (
            getProfessorFeedbackHistoryData?.data.evaluationHistoryList.map(
              (list) => (
                <tr key={list.feedbackDate}>
                  <td>{list.feedbackDate}</td>
                  <td>{list.score}</td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
          {feedbackId === null && (
            <tr>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
        </tbody>
      </table>
    </ModalWrapper>
  );
};

export default EvaluationDetail;
